import { HamburgerRemoveIcon } from './HamburgerRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 52F5DBCE-78B0-49ED-BBDB-73B8F34084A0
 * name hamburger-remove
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hamburger-remove.svg
 * tags
 * - Food / Drink 
 */
export const BurgerRemoveIcon = HamburgerRemoveIcon;
export default BurgerRemoveIcon